import { Brick, registerBrick, ErrorFlow } from 'olympe';

export default class ScenarioQueryGenerator extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} body
     * @param {function()} forwardEvent
     * @param {function(string)} setQueries
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [body], [forwardEvent, setQueries, setErrorFlow]) {

        function generateImpactQueryAndBindings(data) {
            const impacts = data.impacts || [];

            const upsertSQLFragment = !data?.scenarioId
                ? `INSERT INTO cmcdr.cost_model_scenario (
                        sub_scope_id, created_by, prism_cycle, scenario_name, general_comments, additional_notes, last_updt_dttm, status,
                        ppv1_cy_price, ppv2_ly_price, ppv3_cy_volume, ppv4_ly_fx, ppv5_total_var_due_to_price,
                        ppv1_cy_price_ny, ppv2_ly_price_ny, ppv3_cy_volume_ny, ppv4_ly_fx_ny, ppv5_total_var_due_to_price_ny,
                        modified_by
                    )
                    VALUES (:p0, :p1, :p2, :p3, :p4, :p5, :p6, :p7, :p8, :p9, :p10, :p11, :p12, :p13, :p14, :p15, :p16, :p17, :p18);
                    
                    SET @ScenarioID = SCOPE_IDENTITY();
                    SELECT @ScenarioID AS scenarioId;`
                : `UPDATE cmcdr.cost_model_scenario
                    SET sub_scope_id = :p0, created_by = :p1, prism_cycle = :p2, scenario_name = :p3,
                        general_comments = :p4, additional_notes = :p5, last_updt_dttm = :p6, status = :p7,
                        ppv1_cy_price = :p8, ppv2_ly_price = :p9, ppv3_cy_volume = :p10, ppv4_ly_fx = :p11, ppv5_total_var_due_to_price = :p12,
                        ppv1_cy_price_ny = :p13, ppv2_ly_price_ny = :p14, ppv3_cy_volume_ny = :p15, ppv4_ly_fx_ny = :p16, ppv5_total_var_due_to_price_ny = :p17,
                        modified_by = :p18
                    WHERE scenario_id = ${data?.scenarioId};

                    UPDATE cmcdr.cost_model_impacts SET obsolete_flag = 'X' WHERE scenario_id = ${data?.scenarioId};
                    
                    UPDATE cmcdr.results_inputs SET obsolete_flag = 'X' WHERE scenario_id = ${data?.scenarioId};
                    
                    UPDATE cmcdr.results_prices SET obsolete_flag = 'X' WHERE scenario_id = ${data?.scenarioId};`;

            let query = `BEGIN
                DECLARE @ScenarioID INT;

                BEGIN TRY BEGIN TRANSACTION;

                ${upsertSQLFragment}
            `;

            const bindings = {
                p0: data.subscopeId,
                p1: data.createdBy,
                p2: data.cycle,
                p3: data.scenarioName,
                p4: data.generalComments,
                p5: data.additionalNotes,
                p6: data.lastUpdatedAt,
                p7: data.status,
                p8: data.ppv1CyPrice,
                p9: data.ppv2LyPrice,
                p10: data.ppv3CyVolume,
                p11: data.ppv4LyFx,
                p12: data.ppv5TotalVarDueToPrice,
                p13: data.ppv1CyPriceNy,
                p14: data.ppv2LyPriceNy,
                p15: data.ppv3CyVolumeNy,
                p16: data.ppv4LyFxNy,
                p17: data.ppv5TotalVarDueToPriceNy,
                p18: data.modifiedBy
            };

            if (impacts.length > 0) {
                query += `
                    INSERT INTO cmcdr.cost_model_impacts (
                        scenario_id, start_date, end_date, value, impact_comment, is_percentage,
                        cost_component, cost_subcomponent, created_by, last_updt_dttm
                    ) VALUES
                    ${impacts.map((_, i) =>
                        `(${!data?.scenarioId ? '@ScenarioID' : data.scenarioId}, :p${19 + i * 9}, :p${20 + i * 9}, :p${21 + i * 9}, :p${22 + i * 9}, :p${23 + i * 9}, :p${24 + i * 9}, :p${25 + i * 9}, :p${26 + i * 9}, :p${27 + i * 9})`
                    ).join(', ')};
                `;

                impacts.forEach((impact, i) => {
                    bindings[`p${19 + i * 9}`] = impact.startMonth;
                    bindings[`p${20 + i * 9}`] = impact.endMonth;
                    bindings[`p${21 + i * 9}`] = impact.value;
                    bindings[`p${22 + i * 9}`] = impact.comment;
                    bindings[`p${23 + i * 9}`] = impact.percentage;
                    bindings[`p${24 + i * 9}`] = impact.costComponent;
                    bindings[`p${25 + i * 9}`] = impact.costSubcomponent;
                    bindings[`p${26 + i * 9}`] = impact.createdBy;
                    bindings[`p${27 + i * 9}`] = impact.lastUpdatedAt;
                });
            }

            query += `
                    COMMIT TRANSACTION;
                END TRY
                BEGIN CATCH
                    IF @@TRANCOUNT > 0
                        ROLLBACK TRANSACTION;
                    PRINT 'Error occurred. Transaction rolled back.';

                    SELECT
                        ERROR_NUMBER() AS ErrorNumber,
                        ERROR_SEVERITY() AS ErrorSeverity,
                        ERROR_STATE() AS ErrorState,
                        ERROR_PROCEDURE() AS ErrorProcedure,
                        ERROR_LINE() AS ErrorLine,
                        ERROR_MESSAGE() AS ErrorMessage;

                    THROW;
                END CATCH;
            END`;

            return { query, bindings };
        }

        try {
            const result = generateImpactQueryAndBindings(JSON.parse(body));
            setQueries(result);
        } catch (err) {
            setErrorFlow(ErrorFlow.create(`Error ${err} during the execution`));
        }

        forwardEvent();
    }
}

registerBrick('0195b98b2dab428b2f70', ScenarioQueryGenerator);
